import Vue from 'vue'
import delay from 'lodash/delay'
import httpInstance from '@/http'
import router from '@/router'
import { resolve_error_action, clear_session_storage } from '@/utils/http-error'
import { is_token_expired } from '@/utils/auth-token'
import { sessionBus } from '@/utils/session'

// Reaktives HTTP-Objekt erstellen
export const http = new Vue({
    data: {
        isLoading: false,
        requestCounter: 0
    },

    created() {
        // Intercepter für HTTP-Requests
        httpInstance.interceptors.request.use(config => {
            // Auth-Refresh soll silent ausgefuehrt werden
            if (config.method === 'patch' && config.url === 'auth') {
                return config
            }

            // Silent-Requests sollen den globalen Ladeindikator nicht auslösen
            if (config.silent) {
                return config
            }

            this.increment()
            return config
        })

        // Intercepter für HTTP-Responses
        httpInstance.interceptors.response.use(response => {
            if (!response.config.silent) {
                this.decrement()
            }
            return response
        }, error => {
            if (!error.config?.silent) {
                this.decrement()
            }

            const status = error.response && error.response.status
            const action = resolve_error_action(status, {
                isLoggedIn: !!localStorage.getItem('zmk_token'),
                isOnLoginPage: router.currentRoute.name === 'app/login',
                isTokenExpired: is_token_expired()
            })

            if (action.type === 'login') {
                clear_session_storage()
                if (router.currentRoute.name !== 'app/login') {
                    router.push({ name: 'app/login' })
                }
                // Kein reject – verhindert Fehlermeldung im aufrufenden Code nach dem Redirect
                return new Promise(() => {})
            }

            if (action.type === 'session-expired') {
                sessionBus.$emit('session-expired', router.currentRoute.fullPath)
                // Kein reject – das Modal übernimmt die weitere Navigation
                return new Promise(() => {})
            }

            if (action.type === 'error') {
                if (router.currentRoute.name !== 'error') {
                    router.push({ name: 'error', params: { statusCode: action.statusCode } })
                }
                // Kein reject – verhindert Fehlermeldung im aufrufenden Code nach dem Redirect
                return new Promise(() => {})
            }

            if (status >= 500) {
                $('body').toast({
                    class: 'error',
                    message: 'Der Server hat einen Fehler gemeldet. Bitte versuche es erneut.',
                    displayTime: 0,
                    position: 'top right',
                    closeIcon: true
                })
            }

            return Promise.reject(error)
        })

    },

    methods: {

        decrement() {
            delay(() => {
                // Counter nur dekrementieren wenn > 0
                if (this.requestCounter > 0) {
                    this.requestCounter--
                }

                this.isLoading = this.requestCounter !== 0
            }, 50)
        },

        increment() {
            this.requestCounter++
            this.isLoading = true
        },

    }

})



export const plugin = {

    install(Vue) {
        // HTTP-Objekt in Vue speichern
        Vue.http            = http
        Vue.prototype.$http = http
    }

}
